import { BASE_URLS } from './utils/constants';

const config = {
	api: {
		base_url: BASE_URLS[process.env.REACT_APP_APP_ENV] || BASE_URLS.local,
	},
	tiny_url_key: 'hifnzacmp0cqzl92lh5vg6cjoyipu9ih69ajw1kizdlw4y04',
};

export default config;
